import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';
import { ImageStandalone } from '../ImageStandalone';
import { RichTextContent } from '../RichTextContent';

export const StyledBody = styled('div')<{ $isColumnFlow: boolean }>`
    display: flex;
    flex-direction: ${({ $isColumnFlow }) =>
        $isColumnFlow ? 'column' : ' row'};
    flex-wrap: wrap;
`;

export const StyledIcon = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        height: ${theme.tggSpacing(rem(4), 10)};
        padding: ${theme.tggSpacing(px(8), 2)};
        margin-right: ${theme.tggSpacing(px(15), 8)};
        border: ${theme.tggSpacing(rem(0.25), 0.625)} solid
            ${theme.palette.grey[900]};
        border-radius: 100%;

        ${theme.breakpoints.up('desktop')} {
            height: ${theme.tggSpacing(rem(6.2), 15.5)};
            padding: ${theme.tggSpacing(px(12), 3)};
        }
	`}
`;

export const StyledIconText = styled('p')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_19_bold_desktop_21};
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(2), 5)};
        padding: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing(0, 0)};
        text-align: center;
        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(3.4), 14)};
            margin-top: ${theme.tggSpacing(rem(0.8), 3)};
        }
	`}
`;

export const StyledLink = styled('a')<{
    $hasLineUnder: boolean;
}>`
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    text-decoration: ${({ $hasLineUnder }) =>
        $hasLineUnder ? 'underline' : 'none'};
`;

export const StyledImage = styled(ImageStandalone)`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(6), 15)};
        height: ${theme.tggSpacing(rem(6), 15)};
        margin-right: ${theme.tggSpacing(px(15), 8)};

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(8.2), 33)};
            height: ${theme.tggSpacing(rem(8.2), 33)};
        }
	`}
`;

export const StyledItem = styled('div')<{
    $isColumnFlow: boolean;
    theme: Theme;
}>`
    ${({ theme, $isColumnFlow }) => `
        display: flex;
        flex-grow: 0;
        flex-basis: 100%;
        flex-direction: row;
        width: 100%;
        max-width: 100%;
        padding-bottom: ${theme.tggSpacing(px(10), 2.5)};
        word-break: break-all;

        ${theme.breakpoints.up('desktop')} {
            flex-basis: 50%;
            max-width: ${$isColumnFlow ? '100%' : ' 50%'};
            padding-right: ${theme.tggSpacing(px(30), 7.5)};
            padding-bottom: ${theme.tggSpacing(px(30), 7.5)};
        }
	`}
`;

export const StyledContent = styled('div')<{
    $paragraphGutterBottom: boolean;
    theme: Theme;
}>`
    ${({ theme, $paragraphGutterBottom }) => `
        p {
            padding-top: ${theme.tggSpacing(px(3), 0.75)};
            padding-bottom: ${theme.tggSpacing(px(5), 1.25)};
            margin-top: ${theme.tggSpacing(0, 0)};
            margin-bottom: ${$paragraphGutterBottom ? theme.tggSpacing(rem(2), 5) : theme.tggSpacing(0, 0)};
            word-break: keep-all;

            b {
                font-family: thegymgroupsans-Headline, sans-serif;
            }

            ${theme.breakpoints.up('desktop')} {
                padding-top: ${theme.tggSpacing(px(8), 2)};
            }
        }
	`}
`;

export const StyledRichTextContent = styled(RichTextContent)`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(0, 0)};
	`}

    p {
        ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    }
`;
